module.exports = __webpack_public_path__ + "img/sun.7153e452.svg";